<template>
  <div class="preload">
    <div class="preload__bg">
      <Logo />
    </div>
  </div>
</template>

<script>
  import Logo from '@/assets/svg/logo.svg'
  export default {
    name: 'Preload',

    components: {
      Logo
    }
  }
</script>

<style lang="scss">
.preload {
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $c-black;
  transition: 0.5s;

  svg {
    width: 200px;
    height: 36px;
  }

  &_done {
    opacity: 0;
    z-index: -999;
  }
}
</style>
